var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.299,
    height: 39.018,
    viewBox: "0 0 56.299 39.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_24._Container",
    "data-name": "24. Container",
    transform: "translate(0.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M6.728,31.737A1.728,1.728,0,0,1,5,30.009V12.728a1.728,1.728,0,0,1,3.456,0V30.009A1.728,1.728,0,0,1,6.728,31.737Z",
    transform: "translate(3.641 4.369)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M11.728,31.737A1.728,1.728,0,0,1,10,30.009V12.728a1.728,1.728,0,1,1,3.456,0V30.009A1.728,1.728,0,0,1,11.728,31.737Z",
    transform: "translate(7.281 4.369)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M16.728,31.737A1.728,1.728,0,0,1,15,30.009V12.728a1.728,1.728,0,0,1,3.456,0V30.009A1.728,1.728,0,0,1,16.728,31.737Z",
    transform: "translate(10.922 4.369)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M21.728,31.737A1.728,1.728,0,0,1,20,30.009V12.728a1.728,1.728,0,0,1,3.456,0V30.009A1.728,1.728,0,0,1,21.728,31.737Z",
    transform: "translate(14.562 4.369)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M26.728,31.737A1.728,1.728,0,0,1,25,30.009V12.728a1.728,1.728,0,0,1,3.456,0V30.009A1.728,1.728,0,0,1,26.728,31.737Z",
    transform: "translate(18.203 4.369)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M53.571,39.562V11.912a1.728,1.728,0,0,0,0-3.456H46.659V6.728a1.728,1.728,0,0,0-3.456,0V8.456H10.369V6.728a1.728,1.728,0,0,0-3.456,0V8.456H1.728a1.728,1.728,0,0,0,0,3.456v27.65a1.728,1.728,0,0,0,0,3.456H53.571a1.728,1.728,0,0,0,0-3.456Zm-3.456,0H5.184V11.912H50.115Z",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/Container.3cce02cec0e2f0e4f33123822cd07a27.svg";
export { ForwardRef as ReactComponent };